/* The ONE celebration — a burst of coloured squares that fall and fade, fired
   when the day is done. Port of app/src/components/Confetti.tsx. */
import React, { useMemo } from 'react';

const COLORS = ['#17BEB4', '#FB8B24', '#9B5DE5', '#FF4D8D', '#2E9BFF', '#2FBF4F', '#FFC93C'];
const COUNT = 70;

export function Confetti({ fireKey }: { fireKey: number }) {
  const pieces = useMemo(() => {
    let s = (fireKey * 2654435761) >>> 0 || 1;
    const rnd = () => { s = (s * 1103515245 + 12345) & 0x7fffffff; return s / 0x7fffffff; };
    return Array.from({ length: COUNT }, (_, i) => ({
      color: COLORS[i % COLORS.length]!,
      left: (rnd() - 0.5) * 240,
      size: 6 + rnd() * 6,
      driftX: (rnd() - 0.5) * 260,
      rise: 60 + rnd() * 160,
      delay: rnd() * 140,
      rot: rnd() * 720 - 360,
    }));
  }, [fireKey]);
  if (!fireKey) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" aria-hidden>
      {pieces.map((p, i) => (
        <span
          key={`${fireKey}-${i}`}
          className="confetti-piece"
          style={{
            left: `calc(50% + ${p.left}px)`, top: '38%', width: p.size, height: p.size * 0.7, background: p.color,
            animationDelay: `${p.delay}ms`,
            ['--dx' as string]: `${p.driftX}px`, ['--rise' as string]: `${-p.rise}px`, ['--rot' as string]: `${p.rot}deg`,
          }}
        />
      ))}
    </div>
  );
}
